import {
  // useLocation,
  // useNavigate,
  // useParams,
  useSearchParams
} from 'react-router-dom';
    
export default function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const 
          // location = useLocation(),
          // navigate = useNavigate(),
          // params = useParams(),
          search = useSearchParams()
          ;
    
    return (
      <Component
        {...props}
        router={{
          // location,
          // navigate,
          // params,
          search
        }}
      />
    );
  }

  return ComponentWithRouterProp;
}